module.exports = __webpack_public_path__ + "img/app12.3ad22abb.png";